<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="history" />
          {{ $t('activityHistory') }}
        </h1>
      </div>
    </div>
    <client-log></client-log>
  </main>
</template>

<script>
import ClientLog from "@/views/client/ClientLog.vue";

export default {
  components: { ClientLog },
  data() {
    return {
    }
  },
  i18n: {
    messages: {
      en: {
        activityHistory: "Activity history",
      },
      vi: {
        activityHistory: "Lịch sử hoạt động",
      }
    }
  }
}
</script>